import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

export default function Card(props) {

  const useStyles = makeStyles({
    myCard: {
      backgroundColor: "#F7F5F3",
      padding: "27.5px 32px",
      textAlign: "center",
      flexGrow: 1,
      borderRadius: "8px"
    },
    firstCard: {
      backgroundColor: "#E8E2DE"
    },
    paid: {
      color: "#02C875"
    },
    numberinstallment: {
      paddingTop: "6px"
    }
  });

  const classes = useStyles();

  return (
    <div className={classes.myCard + " " + (props.firstCard? classes.firstCard : "")}>
      { props.header && <div className="regular-b300">{props.header}</div> }
      { props.body && <div className={"semibold-h300 paddingBottom16 " + (props.paid? "cl-secondary-500" : "")}>{props.body}</div> }
      { props.footer && <div className={"semibold-b100 cl-secondary-500 " + (props.paid? classes.paid : "")}>{props.footer}</div> }
      { props.numberinstallment && <div className={classes.numberinstallment + " regular-b300"}>{props.numberinstallment}</div> }
    </div>
  );
}